import React from 'react';
import {connect} from 'react-redux';
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";
import {arrivalAirportSelected, clearFilter} from "../../actions/FlightsActions";
import {bindActionCreators} from "redux";
import PriceFormatter from "../../helpers/PriceFormatter";
import BaseFilterComponent from "./BaseFilterComponent";
import {registerAppliedFilter} from "../../actions/FilterGroupsActions";
import {UncontrolledTooltip} from "reactstrap";

class ArrivalAirportBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = 'arrivalAirports';
        this.name = 'Arrival airport';
        this.urlEnabled = props.urlFilters.arrivalAirports && props.urlFilters.arrivalAirports.length !== 0;
    }

    renderAirportList() {
        let list = [];
        for (const key of Object.keys(this.props.arrivalAirports)) {
            list.push(this.renderAirport(key, this.props.arrivalAirports[key]))
        }

        return list;
    }

    selectAirport(code, e) {
        this.props.arrivalAirportSelected(code);
    }

    renderAirport(code, airport) {
        return (
            <div className="form-check" key={code}>
                <label className="form-check-label">
                    <input checked={this.props.selected.indexOf(code) !== -1}
                           onChange={this.selectAirport.bind(this, code)} className="form-check-input" type="checkbox"
                           value={code}/>
                    <small id={`arrival-airport-name-${code}`}>{code} {airport.title}</small>
                    <UncontrolledTooltip delay={0} placement="top" target={`arrival-airport-name-${code}`}>
                        {airport.title}
                    </UncontrolledTooltip>
                </label>
                <span className="tag badge badge-warning float-right"
                      {...this.priceFormatter.format(airport.price, true)}
                ></span>
            </div>
        );
    }

    render() {
        if (Object.keys(this.props.arrivalAirports).length <= 1) {
            return null;
        }

        this.priceFormatter = new PriceFormatter(this.props.parameters['price-format']);
        const translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="font-weight-bold mb-2">{translator.trans(this.name)}</div>
                    {this.renderClearFilterButton()}
                    {this.renderAirportList()}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        arrivalAirportSelected,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        arrivalAirports: state.ArrivalAirportsFilterReducer.airports,
        selected: state.ArrivalAirportsFilterReducer.selected,
        parameters: state.ParametersReducer.parameters,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArrivalAirportBlock);



// WEBPACK FOOTER //
// ./src/components/filters/ArrivalAirportBlock.js